<template>
  <div>
    <div class="flex items-center justify-between mt-6 mb-3">
      <h3 class="text-lg font-semibold">Historical</h3>
      <div class="flex items-center gap-4">
        <div v-if="isAllScope && !allowAllScopeHistorical" class="text-xs text-gray-500">Historical shown per university. Select a university to view.</div>
        <template v-else>
          <div class="flex items-center gap-2">
            <label class="text-sm text-gray-600">Time range</label>
            <div class="flex gap-1">
              <TimeRangePresetButtons
                :presets="presets"
                :active-preset="activePreset"
                compact
                @apply-preset="$emit('apply-preset', $event)"
              />
              <button @click="toggleCustomProxy = !toggleCustomProxy" class="px-2 py-1 rounded border bg-white hover:bg-gray-50 text-xs">Custom</button>
            </div>
            <div v-if="toggleCustom" class="flex items-end gap-2 ml-2">
              <div>
                <label class="block text-xs text-gray-600 mb-1">From</label>
                <input v-model="customFromProxy" type="datetime-local" class="border rounded px-2 py-1 text-sm" />
              </div>
              <div>
                <label class="block text-xs text-gray-600 mb-1">To</label>
                <input v-model="customToProxy" type="datetime-local" class="border rounded px-2 py-1 text-sm" />
              </div>
              <button @click="$emit('apply-custom')" class="px-3 py-2 rounded bg-black text-white text-xs">Apply</button>
            </div>
            <button @click="$emit('load-engagement')" class="ml-2 bg-black text-white px-3 py-2 rounded text-xs">Refresh</button>
            <button
              @click="$emit('export-report')"
              :disabled="isAllScope || exporting"
              :class="['ml-2 px-3 py-2 rounded text-xs border', isAllScope || exporting ? 'bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200' : 'bg-white hover:bg-gray-50']"
            >
              {{ exporting ? 'Exporting...' : 'Export PDF' }}
            </button>
          </div>
        </template>
      </div>
    </div>
    <div v-if="exporting" class="text-xs text-gray-500 mt-2 mb-2 flex items-center gap-2" aria-live="polite">
      <span class="spinner" aria-hidden="true"></span>
      Generating PDF... this can take a few seconds.
    </div>
    <div v-if="exportError" class="text-xs text-red-600 mt-2">{{ exportError }}</div>
    <div v-if="loading || breakdownsLoading || engagementInsightsLoading || isCeremonyBreakdownLoading" class="mt-2 mb-3 text-sm text-gray-600 flex items-center gap-2" aria-live="polite">
      <span class="spinner" aria-hidden="true"></span>
      <span>{{ engagementPrimaryLoadingText }}</span>
    </div>
  </div>
</template>

<script>
import TimeRangePresetButtons from '../shared/TimeRangePresetButtons.vue'

export default {
  name: 'EngagementHistoricalControlsSection',
  components: { TimeRangePresetButtons },
  props: {
    isAllScope: { type: Boolean, default: false },
    allowAllScopeHistorical: { type: Boolean, default: false },
    presets: { type: Array, default: () => [] },
    activePreset: { type: String, default: '' },
    toggleCustom: { type: Boolean, default: false },
    customFrom: { type: String, default: '' },
    customTo: { type: String, default: '' },
    exporting: { type: Boolean, default: false },
    exportError: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    breakdownsLoading: { type: Boolean, default: false },
    engagementInsightsLoading: { type: Boolean, default: false },
    isCeremonyBreakdownLoading: { type: Boolean, default: false },
    engagementPrimaryLoadingText: { type: String, default: '' },
  },
  computed: {
    toggleCustomProxy: {
      get() {
        return this.toggleCustom
      },
      set(value) {
        this.$emit('update:toggleCustom', Boolean(value))
      },
    },
    customFromProxy: {
      get() {
        return this.customFrom
      },
      set(value) {
        this.$emit('update:customFrom', String(value || ''))
      },
    },
    customToProxy: {
      get() {
        return this.customTo
      },
      set(value) {
        this.$emit('update:customTo', String(value || ''))
      },
    },
  },
}
</script>
